import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'


export function columnsServiceXS(columnOption) {
    return ([
        {
            dataField: 'id',
            text: 'Servicios Seleccionados',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Nombre Servicio:' value={row.name} />
                        <TableRowField label='Descuento:' value={`${row.discount} %`} />
                        <TableRowField label='Precio (S/):' value={formatHelper.toMoney(row.price)} />
                    </div>
                )
            }
        },
        columnOption
    ])
}
export function columnsServiceSM(columnOption) {
    return ([
        {
            dataField: 'Service',
            text: 'Nombre Servicio',
            formatter: (cell, row) => {
                return (
                    <span>{row.name}</span>
                )
            }
        },
        {
            dataField: 'discount',
            text: 'Descuento',
            formatter: (cell, row) => {
                return (
                    <span>{`${cell} %`}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}

export function columnsService(columnOption) {
    return ([
        {
            dataField: 'Service',
            text: 'Nombre Servicio',
            formatter: (cell, row) => {
                return (
                    <span>{row.name}</span>
                )
            }
        },
        {
            dataField: 'discount',
            text: 'Descuento',
            formatter: (cell, row) => {
                return (
                    <span>{`${cell} %`}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}

export function columnsProductXS(columnOption) {
    return ([
        {
            dataField: 'id',
            text: 'Productos Seleccionados',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Nombre Producto:' value={row.name} />
                        <TableRowField label='Descuento:' value={`${row.discount} %`} />
                        <TableRowField label='Precio (S/):' value={formatHelper.toMoney(row.price)} />
                    </div>
                )
            }
        },
        columnOption
    ])
}

export function columnsProductSM(columnOption) {
    return ([
        {
            dataField: 'Product',
            text: 'Nombre Producto',
            formatter: (cell, row) => {
                return (
                    <span>{row.name}</span>
                )
            }
        },
        {
            dataField: 'discount',
            text: 'Descuento',
            formatter: (cell, row) => {
                return (
                    <span>{`${cell} %`}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}

export function columnsProduct(columnOption) {
    return ([
        {
            dataField: 'Product',
            text: 'Nombre Producto',
            formatter: (cell, row) => {
                return (
                    <span>{row.name}</span>
                )
            }
        },
        {
            dataField: 'discount',
            text: 'Descuento',
            formatter: (cell, row) => {
                return (
                    <span>{`${cell} %`}</span>
                )
            }
        },
        {
            dataField: 'price',
            text: 'Precio (S/)',
            formatter: (cell, row) => {
                return (
                    <span>{formatHelper.toMoney(cell)}</span>
                )
            }
        },
        columnOption
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Offer/OfferAdd/_columns.js